import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useGateValue } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

const WhyOuraResearch = () => {
  const t = useTranslations();

  return (
    <section className="relative py-16" data-cy="why-oura-research">
      <LayoutGrid>
        <GridItem
          className="pb-16 lg:px-4 lg:pb-32"
          colEnd={{ sm: 'main', md: 21, lg: 20 }}
          colStart={{ sm: 'main', md: 5, lg: 6 }}
        >
          <Motion
            initial={{ filter: 'blur(10px)' }}
            whileInView={{ filter: 'blur(0px)', transition: { duration: 1 } }}
            viewport={{ once: true }}
          >
            <Typography Element="h3" variant="h1" align="center" height="tight">
              <RichText
                messageKey={
                  useGateValue('oura_stat_roll_out')
                    ? 'why_oura_research_stat'
                    : 'research_title'
                }
              />
            </Typography>
          </Motion>
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <div className="flex flex-wrap divide-y divide-sandstone-500 lg:divide-x lg:divide-y-0">
            <div className="flex w-full flex-col items-center py-10 lg:w-1/3 lg:px-4 lg:py-0">
              <Typography
                className="mb-5 text-5xl"
                font="serif"
                weight="thin"
                variant="unset"
                align="center"
              >
                {t(
                  useGateValue('oura_stat_roll_out')
                    ? 'why_oura_phd_stat'
                    : '20_phd_heading',
                )}
              </Typography>
              <Typography className="w-10/12 text-center">
                {t('20_phd_copy')}
              </Typography>
            </div>
            <div className="flex w-full flex-col items-center py-10 lg:w-1/3 lg:px-4 lg:py-0">
              <Typography
                className="mb-5 text-5xl"
                font="serif"
                weight="thin"
                variant="unset"
                align="center"
              >
                {t('4_gen_heading')}
              </Typography>
              <Typography className="w-10/12 text-center">
                {t('3_gen_copy')}
              </Typography>
            </div>
            <div className="flex w-full flex-col items-center pt-10 lg:w-1/3 lg:px-4 lg:py-0">
              <Typography
                className="mb-5 text-5xl"
                font="serif"
                weight="thin"
                variant="unset"
                align="center"
              >
                {t(
                  useGateValue('oura_stat_roll_out')
                    ? 'why_oura_ring_members_stat'
                    : 'members_heading',
                )}
              </Typography>
              <Typography className="w-10/12 text-center">
                {t('members_copy')}
              </Typography>
            </div>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default WhyOuraResearch;
